import axios from 'axios'
import bowser from 'bowser'
const PROTOCOL = window.location.protocol || 'http:'
export const Common = {
  checkEntry () {
    const curUrl = window.location.href
    return (window.location.href = `${PROTOCOL}//nw.zhaopin.com/cas/login?service=${curUrl}`)
  },
  getMsgVNode (fn, h, err, callback) { // 异常呈现
    let status = err.reload ? 'error' : 'warning'
    if (err.config) {
      const errMsg = err.message || err.config.msg || err.config.message
      err.networkError && (status = 'info')
      const hasTraceId = err.traceId ? '' : 'none'
      fn(errMsg, {
        type: status, // 级别
        duration: 0, // 一直停留
        length: 34, // 截取字符长度
        showClose: true, // 是否显示关闭
        position: 'top', // 位置
        more: {
          openText: '点击诊断',
          closeText: '',
          height: '160px',
          content: h('div', {
            style: {
              lineHeight: '16px'
            }
          }, [
            h('span', {
              style: {
                color: '#8d8d8d'
              }
            }, '时间：'),
            h('span', null, `${new Date().toLocaleString()}`),
            h('br'),
            h('span', {
              style: {
                color: '#8d8d8d',
                display: hasTraceId
              }
            }, 'traceId：'),
            h('span', {
              style: {
                display: hasTraceId
              }
            }, err.traceId || ''),
            h('br', {
              style: {
                display: hasTraceId
              }
            }),
            h('div', {
              style: {
                color: '#8d8d8d',
                float: 'left'
              }
            }, '浏览器：'),
            h('div', {
              style: {
                float: 'left'
              }
            }, `${bowser.name} ${bowser.version}`),
            h('div', {
              style: {
                float: 'right'
              }
            }, `${bowser.osname} ${bowser.osversion}`),
            h('div', {
              style: {
                color: '#8d8d8d',
                float: 'right'
              }
            }, '操作系统：'),
            h('br', {
              style: {
                clear: 'both'
              }
            }),
            h('span', {
              style: {
                color: '#8d8d8d'
              }
            }, '请求方式：'),
            h('span', null, `${err.config.method.toUpperCase()}`),
            h('br'),
            h('div', {
              style: {
                color: '#8d8d8d',
                float: 'left'
              }
            }, '请求URL：'),
            h('div', {
              style: {
                float: 'left',
                width: '300px'
              }
            }, `${err.config.url}`),
            h('br', {
              style: {
                clear: 'both'
              }
            }),
            h('div', {
              style: {
                color: '#8d8d8d',
                float: 'left'
              }
            }, '异常信息：'),
            h('div', {
              style: {
                float: 'left',
                width: '300px'
              }
            }, `${errMsg}`)
          ])
        }
      }).then(() => {
        setTimeout(() => { // 等待消息动画结束后执行
          callback && callback()
        }, 500)
      })
    } else {
      fn(err.message, {
        type: 'warning', // 级别
        duration: 0, // 一直停留
        showClose: true, // 是否显示关闭
        position: 'top', // 位置
      })
    }
  },
  handleError (err, vm, fn) { // 异常处理
    console.log(`%c ${err.message}`, 'background: #222; color: #bada55')
    // throw new Error(err)
    try {
      if (err.message.includes('Network Error')) {
        err.message = '你的网络开了个小差儿，刷一下~'
        err.networkError = true
        process.env.NODE_ENV !== 'development' && (err.reload = true)
      }
      if (vm) {
        let alertFn = vm.$zpMessage
        if (err.entry) { // 跳回单点
          return this.deleteSession()
        } else if (err.reload) { // 尝试重新刷新当前页获取token
          Common.getMsgVNode(alertFn, vm.$createElement, err, () => {
            const url = `${PROTOCOL}//inner-login.zhaopin.com/login/getToken`
            axios(url).then(res => { // 远端获取token
              window.location.reload()
            }).catch(e => Common.handleError(e, vm))
          })
        } else {
          Common.getMsgVNode(alertFn, vm.$createElement, err)
        }
      }
    } catch (e) {
      fn && fn()
    }
  },
  getCookie (name) { // 获取cookie
    const cookieContent = '; ' + document.cookie
    const cookies = cookieContent.split(`; ${name}=`)
    return cookies.length - 1 ? cookies.pop().split(';').shift() : ''
  },
  setCookie (name, val, days) { // 设置cookie
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = `; expires=${date.toUTCString()}`
    }
    document.cookie = `${name}=${val}${expires}; path=/`
  },
  delCookie (name) { // 移除cookie
    this.setCookie(name, '', -1)
  },
  //退出系统时调用
  // deleteSession () {
  //   localStorage.clear()
  //   const curUrl = window.location.href
  //   return (window.location.href = `//zpsso.zhaopin.com/logout?service=${curUrl}`)
  // }
}
if(Common.getCookie('qds_version_id') == 'v2') axios.defaults.headers.common['qds_version_id'] = 'v2' // 灰度测试用
axios.interceptors.response.use(res => {
  // Resolve
  // 二次验证
  // const data = res.data
  // if (data.hasOwnProperty('success') && data.success === false) {
  //   data.config = res.config
  //   return Promise.reject(data)
  // }
  return res
}, err => {
  // Reject
  if (err && err.response) { // 接口异常
    err.url = err.response.request && err.response.request.responseURL || ''
    // const errCode = err.response.status
    const data = err.response.data
    err.message = data && (data.msg || data.message) || err.message
    if ((err.message.includes('token') || err.message.includes('JWT')) && process.env.NODE_ENV !== 'development') { // token失效
      const auth = Common.getCookie('INNER_AUTHENTICATION')
      let token
      try {
        token = auth && atob(auth)
      } catch (e) {
        token = null
      }
      if (!token || err.message.includes('expired') || err.message.includes('请登录cas')) { // 关键字 --|||
        err.entry = true
      } else {
        err.reload = true
      }
    }
    (err.message.includes('cookie[INNER_AUTHENTICATION]')) && process.env.NODE_ENV !== 'development' && (err.entry = true)
  } else { // xhr异常
    process.env.NODE_ENV !== 'development' && (err.reload = true) // 尝试刷新当前页
  }
  return Promise.reject(err)
})



// WEBPACK FOOTER //
// ./src/common.js